<template>
    <div>
        <div class="pb-1" v-if="showHeader">
            <h3>Product information</h3>
        </div>
        <table>
            <tbody>
            <tr>
                <th>{{ productNameLabel }}:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">{{ getProductName(product.names) }}</span>
                </td>
            </tr>
            <tr>
                <th>{{ productIdLabel }}:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">{{ getProductId(product.identifiers) }}</span>
                </td>
            </tr>
            <tr>
                <th>{{ scipNameLabel }}:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">{{ scipName }}</span>
                </td>
            </tr>
            <tr>
                <th>{{ scipNumberLabel }}:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">{{ scipId }}</span>
                </td>
            </tr>
            <tr>
                <th>Categories:</th>
                <td>
                    <span class="alert-warning pl-1 pr-1">
                        {{ product.categories.map(c => c.code).filter(c => c).join(', ') }}
                    </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import ReplyTabProductSection from "@core/mixins/ui/reply-tab-product-section";
import {getScipId, getScipName} from "@/libs/product";

export default {
    mixins: [ReplyTabProductSection],
    props: {
        product: {
            required: true,
            default() {
                return {
                    categories: []
                };
            }
        },
        showHeader: {
            default: true
        }
    },
    computed: {
        scipName() {
            return getScipName(this.product);
        },
        scipId() {
            return getScipId(this.product);
        }
    }
}
</script>
